import { SERVER_URL } from '../../../constants';
import {
  fetchGetAuth,
  fetchPostAuth,
  fetchRemoveAuth
} from '../../../util/FetchUtil';

const controller = 'evento-usuario/';

const page = (pageNumber) => {
  const url = SERVER_URL + controller + 'page?page=' + pageNumber;
  return fetchGetAuth(url);
}

const findByEventoCodigo = (codEvento, page) => {
  const url = SERVER_URL + controller + 'engajamento/' + codEvento + "?page=" + page;
  return fetchGetAuth(url);
}

const getEngajamentoInfo = (codEvento) => {
  const url = SERVER_URL + controller + 'engajamento-info/' + codEvento;
  return fetchGetAuth(url);
}

const save = (comunicado) => {
  const url = SERVER_URL + controller;
  return fetchPostAuth(url, comunicado);
}

const remove = (codComunicado) => {
  const url = SERVER_URL + controller + codComunicado;
  return fetchRemoveAuth(url);
}

export {
  page,
  save,
  remove,
  findByEventoCodigo, 
  getEngajamentoInfo
}